import Events from '@clearkit/icons/glyphs/Event';
import Filter from '@clearkit/icons/glyphs/Filter';
import FilterActive from '@clearkit/icons/glyphs/FilterActive';
import Pageview from '@clearkit/icons/glyphs/View';
import {
  CKActionMenu,
  CKButton,
  CKPopover,
  CKTab,
  CKTabList,
  CKTabs,
} from 'clearkit';

import SearchTextField from '~/components/SearchTextField';
import Select from '~/components/Select';
import { CompanyEventsList } from '~/components/Sidebar/CompanyEventsList/EventsList.tsx';
import { CompanyPageviewsList } from '~/components/Sidebar/CompanyEventsList/PageviewsList.tsx';
import { useEventTypes } from '~/components/Sidebar/hooks/useEventTypes.ts';

const CompanyActivity = ({ company, className }) => {
  const [type, setType] = useState();
  const [path, setPath] = useState('');
  const [tabIndex, setTabIndex] = useState(0);
  const [excludingAnonymous, setExcludingAnonymous] = useState(false);
  const { eventTypes } = useEventTypes();

  const toggleHideAnonymous = () => {
    setExcludingAnonymous(!excludingAnonymous);
  };

  return (
    <div className={className}>
      <div className="flex flex-row justify-between px-8 py-6 border-b border-gray-200 align-center bg-gray-0">
        <CKTabs isSegmented index={tabIndex} onChange={setTabIndex}>
          <CKTabList aria-label="My tabs">
            <CKTab label="Pageviews" id="page" icon={<Pageview />}>
              Pageviews
            </CKTab>
            <CKTab label="Events" id="events" icon={<Events />}>
              Events
            </CKTab>
          </CKTabList>
        </CKTabs>

        {tabIndex === 0 && (
          <>
            <SearchTextField
              placeholder="Search by path..."
              className="flex-grow w-6/12 max-w-md ml-auto mr-4"
              onSearch={(e) => {
                let value = e.target.value;
                if (value && !value.startsWith('/')) {
                  value = `/${value}`;
                }
                setPath(value);
              }}
              value={path}
            />
            <CKPopover
              className="z-30"
              gutter={6}
              placement="bottom-start"
              popover={
                <CKActionMenu visible>
                  <CKActionMenu.Checkbox
                    id="toggle-anonymous"
                    checked={excludingAnonymous}
                    onChange={toggleHideAnonymous}>
                    Hide anonymous pageviews
                  </CKActionMenu.Checkbox>
                </CKActionMenu>
              }>
              <CKButton>
                {excludingAnonymous ? (
                  <FilterActive className="text-blue" />
                ) : (
                  <Filter />
                )}
              </CKButton>
            </CKPopover>
          </>
        )}

        {tabIndex === 1 && (
          <Select
            className="flex-grow w-6/12 max-w-md"
            options={['', ...eventTypes]}
            getOptionValue={(option) => option || 'All'}
            getOptionLabel={(option) => option || 'All events'}
            placeholder="Filter by event type"
            onChange={(value) => setType(value)}
            isDisabled={!eventTypes?.length}
            value={[type || 'All events']}
          />
        )}
      </div>
      <div className="flex flex-col flex-grow">
        {tabIndex === 0 && (
          <CompanyPageviewsList
            company={company}
            path={path}
            excludingAnonymous={excludingAnonymous}
            className="px-8"
          />
        )}
        {tabIndex === 1 && (
          <CompanyEventsList
            company={company}
            type={type}
            className="flex flex-col flex-grow px-4"
          />
        )}
      </div>
    </div>
  );
};

CompanyActivity.propTypes = {
  company: PropTypes.object.isRequired,
  className: PropTypes.string,
};

export default CompanyActivity;
